import React, { useEffect, useState } from 'react'

export default function CustomizeSponsorshipModal({type, amount, plans, close, proceed}) {
    const [amounts, setAmount] = useState(amount)
    const [plan, setPlans] = useState(plans.length > 0 ? plans : [])
    const [value, setValue] = useState();
    const [editID, setEditID] = useState(null);


    const validateData = () => {
        if (type == 'fixed' && amounts <= 2) {
            Alert.show('error', 'Amount must be greater than 2')
            return
        }

        if (type == 'plans' && plan.length == 0) {
            Alert.show('error', 'You must have at least one plan')
            return
        }

        proceed(amounts, plan)
        setPlans(null)
        setAmount(null)
        setValue(null)
        setEditID(null)
    }

    const updatePlan = () => {
        // validate data
        if (!value || value < 2) {
            Alert.show('error', 'Amount must be greater than 2')
            return
        }

        if (!editID) {
            setPlans([...plan, {id: plan.length + 1, value: value}])
        }

        if (editID) {
            setPlans(plan.map(item => {
                if (item.id == editID) {
                    return {id: editID, value: value}
                }
                return item
            }))
        }

        setValue('')
        setEditID(null)
    }

    const deletePlan = (id) => {
        setPlans(plan.filter(item => item.id !== id))
    }

  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div className="bg-white mx-auto rounded shadow p-5 text-center cu-width-input">
                <h4>Donation Amount</h4>
                {/* plans view */}
                {type === 'multiple' && plan.map((item, index) => (
                    <div key={index} className='d-flex justify-content-between align-items-center mb-2'>
                        <p>{item.value}</p>
                        <button
                            type='button' 
                            className='btn btn-icon' 
                            style={{border: 'none'}}
                        >
                            <i 
                                className='fa fa-pencil text-primary mr-2'
                                onClick={() => {setEditID(item.id); setValue(item.value)}}
                            >
                            </i>
                            <i 
                                className='fa fa-trash text-danger'
                                onClick={() => deletePlan(item.id)}
                            >
                            </i>
                        </button>
                    </div>
                ))}

                {/* for fixed sponsorship */}
                {type === 'fixed' && 
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='form-group'>
                                <label htmlFor='name'>Amount (USD)</label>
                                <input type='number' step="1" className='form-control' name='name' id='name' placeholder='Amount' 
                                    value={amounts} onChange={(event) => setAmount(event.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                }

                {/* for plans */}
                {type === 'multiple' &&
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='form-group'>
                                <label htmlFor='name'>Amount (USD)</label>
                                <div className="input-group">
                                    <input type='number' step="1" className='form-control' name='name' id='name' placeholder='Amount' 
                                        value={value} onChange={(event) => setValue(event.target.value)}
                                    />
                                    <div className="input-group-append">
                                        <button 
                                            className="btn btn-light btn-border" 
                                            type="button" 
                                            onClick={updatePlan}
                                            disabled={!value}
                                        >
                                            {editID ? 'Update' : 'Add'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <div className="pt-3">
                    <button onClick={validateData} type="button" className="btn btn-primary mr-2">
                        Proceed
                    </button>

                    <button onClick={close} type="button" className="btn btn-secondary mr-2">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}
